import { StatusTimelineClosed, StatusTimelineCurrent, StatusTimelinePast } from 'redesign/components/atoms/Icon'
import { TIMELINE_STATUS } from 'redesign/components/organisms/timeline-item/constants'

export const getStatusTimeline = ({ status }: { status: keyof typeof TIMELINE_STATUS }) => {
  switch (status) {
    case TIMELINE_STATUS.past:
      return StatusTimelinePast

    case TIMELINE_STATUS.closed:
      return StatusTimelineClosed

    default:
      return StatusTimelineCurrent
  }
}
